export enum InventoryStatus {
    IN_STOCK = 'IN_STOCK',
    OUT_OF_STOCK = 'OUT_OF_STOCK',
    PRE_ORDER = 'PRE_ORDER',
    DISCONTINUED = 'DISCONTINUED'
}

export interface SegmentsMachinePriceDto {
    id: string;
    imageUrl: string;
    videoUrl?: string;
    hostingCost: number;
    setupFee: number;
    transportFee: number;
    insurancePercentage: number;
    machinePriceUsd: number;
    deposit: number;
    depositDays: number;
}

export interface SegmentsMachineResponseDto {
    machineModelName: string;
    machineHashrate: number;
    hashrateUnit: string;
    machinePower: number;
    batchReferenceId: string;
    vendor: string;
    algorithm: string;
    inventoryStatus: InventoryStatus;
    prices: SegmentsMachinePriceDto[];
    setupType: string;
}
